import { Directive } from "@app/components/directive";
import { Dirs } from "@app/helpers/dirs";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgComponent({
    token: Token.KbDataGrid,
    dependencies: [
    ]
})
export class KbDataGrid extends Directive {
    constructor() {
        super();

        this.replace = true;
        this.template = Dirs.component("kb-data-grid");
        this.restrict = "AE";
        this.scope = false;
        this.transclude = true;

        this.controller = ["$scope", "$element", function($scope, $element) {
            let columns = $scope.columns = [];

            this.addColumn = column => {
                let exists: boolean = columns.some(c => c.id == column.id);
                if (!exists) {
                    columns.push(column);
                    column.$on("$destroy", event => {
                        columns.remove(column);
                    });
                }
            };
        }];
        this.link = (scope: any, element, atts: any) => {
            scope.ngModel = scope.$eval(atts.ngModel);
        };

    }

}
